export default __webpack_public_path__ + "static/media/settings.3a36363f.svg";